import { useStore } from 'vuex';
import { computed } from 'vue';
import { SET_MODAL_OVERLAY_VISIBILITY } from '@atomic-ui/modalOverlay';

const SET_MODAL_OVERLAY_VISIBILITY_MUTATION = `modalOverlayStore/${SET_MODAL_OVERLAY_VISIBILITY}`;

/**
 * Composable function to open and close modal windows
 * TODO: should be refactored to use createSharedComposable
 *
 * @returns {{
 *  open: (name: ModalName) => void,
 *  close: (name: ModalName) => void,
 *  activeModal: import('vue').ComputedRef<string | undefined>
 * }}
 */
export function useModal() {
  const store = useStore();

  /**
   * Opens named modal window
   * @param {ModalName} name - name of modal window to open
   */
  const open = (name) => {
    store.commit(SET_MODAL_OVERLAY_VISIBILITY_MUTATION, name);
  };

  /**
   * Closes named modal window
   * @param {ModalName} name - name of modal window to close
   */
  const close = (name) => {
    store.commit(SET_MODAL_OVERLAY_VISIBILITY_MUTATION, name);
  };

  /**
   * Returns name of active modal window
   * @returns {import('vue').ComputedRef<string | undefined>}
   */
  const activeModal = computed(() => {
    const showModalObj = store.state.modalOverlayStore.showModal;

    return Object.keys(showModalObj).find((key) => !!showModalObj[key]);
  });

  return { open, close, activeModal };
}

export default useModal;
